import L10n from "../../../lib/carrot-l10n"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { Spacer } from "../atoms/Atoms"
import { BodyLarge, BodySmall } from "../atoms/Bodies"
import React from "react"
import { ArrowLink } from "../atoms/links/ArrowLink"
import Settings from "../../../utils/CarrotConfig"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const supportCenterUrl = Settings.ZENDESK_GUIDE

async function goToSupportCenter() {
  window.open(supportCenterUrl, "_blank")
}

export const SupportCenterModule = () => (
  <RoundedRectangle id="home-sidebar-support-center-module" backgroundColor="pampas">
    <BodyLarge color="black-80" font="publico-headline">
      {l`Get answers to frequently asked questions`}
    </BodyLarge>
    <Spacer height={1.0} />
    <ArrowLink onClick={() => goToSupportCenter()}>{l`Visit Support Center`}</ArrowLink>
  </RoundedRectangle>
)
